import CourseInfo from './CourseInfo';
export default CourseInfo;